import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';
import {
  formatCurrency,
  formatCurrencyDecimals,
  formatNumber,
} from 'utils/formats';
import {
  TradingOffersSummary,
  TradingOfferType,
} from '../../../../../types/TradingOffer';

type TradingOffersSummaryCardProps = {
  type: TradingOfferType;
  summary: TradingOffersSummary;
  societyId: string;
  isButtonVariant?: boolean;
};

const TradingOffersSummaryCard: FC<TradingOffersSummaryCardProps> = ({
  type,
  summary,
  societyId,
  isButtonVariant = false,
}) => {
  const { t } = useTranslate();

  const isSellOffer = type === 'SELL';
  const title = isSellOffer ? t('SellOffers') : t('BuyOffers');
  const linkPath = isSellOffer
    ? `/trading-offers-sell/${societyId}`
    : `/trading-offers-buy/${societyId}`;

  return (
    <div className="card card-full h-100">
      <div className="card-inner d-flex flex-column h-100">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="card-title text-base mb-0">{title}</h6>
          {!isButtonVariant && (
            <Link to={linkPath} className="link link-soft is-disable">
              {t('ViewAll')}
            </Link>
          )}
        </div>

        <div className="card-amount mb-2">
          <span className="amount">{formatCurrency(summary.totalAmount)}</span>
        </div>

        <div className="row flex-grow-1">
          <div className="col-4">
            <span className="sub-text d-block">{t('Offers')}</span>
            <span className="lead-text">
              {formatNumber(summary.offersCount)}
            </span>
          </div>
          <div className="col-4">
            <span className="sub-text d-block">{t('Shares')}</span>
            <span className="lead-text">
              {formatNumber(summary.sharesCount)}
            </span>
          </div>
          <div className="col-4">
            <span className="sub-text d-block">{t('AvgPrice')}</span>
            <span className="lead-text">
              {formatCurrencyDecimals(
                summary.sharesCount > 0
                  ? summary.totalAmount / summary.sharesCount
                  : 0
              )}
            </span>
          </div>
        </div>

        {isButtonVariant && (
          <Link to={linkPath} className="btn btn-light btn-block mt-3">
            {t('ViewAll')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default TradingOffersSummaryCard;
